import styled from '@emotion/styled';

export const MainLayoutWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(245, 245, 245, 1) 0%, rgba(245, 245, 245, 1) 100%), rgba(255, 255, 255, 1);
  display: flex;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const SideNavWrapper = styled.div`
  width: ${({ isExpanded }) => isExpanded ? '240px' : '64px'};
  height: 100%;
  flex-shrink: 0;
  position: relative;
  z-index: 10;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const ContentArea = styled.main`
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding-left: ${({ paddingHorizontal }) => paddingHorizontal}px;
  padding-right: ${({ paddingHorizontal }) => paddingHorizontal}px;
  position: relative;
  min-width: 0;
  max-width: calc(100vw - ${({ sidebarExpanded }) => sidebarExpanded ? '240px' : '64px'});
  transition: max-width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;